import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { AsseMaintenanceApi } from "../../../services/AssetService";
import { toast } from "react-toastify";
import { GrHostMaintenance } from "react-icons/gr";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  MenuItem,
  Grid,
} from "@mui/material";
import { Tabs, Tab, Box } from "@mui/material";
const MAX_DESCRIPTION_LENGTH = 500;
const maintenanceTypeOptions = [
  { label: "Preventive", value: "PREVENTIVE" },
  { label: "Corrective", value: "CORRECTIVE" },
];

const AssetMaintenanceModal = ({
  id,
  open,
  onClose,
  afterSubmit,
  title = "Maintenance Asset",
  message = "Are you sure you want to Maintenance this asset? This action cannot be undone.",
}) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    maintenance_type: "",
    description: "",
  });
  const resetForm = () => {
    setForm({
      maintenance_type: "PREVENTIVE",
      description: "",
    });
  };
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open]);

  const handleInputChange = (name, value) => {
    setForm({ ...form, [name]: value || "" });
  };
  const handleMaintenance = () => {
    setLoading(true);
    AsseMaintenanceApi(id, form)
      .then((res) => {
        toast.success("Maintenance Successfully");
        afterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className="d-flex align-items-center gap-2 text-warning">
        <GrHostMaintenance /> {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" className="mb-3">
          {message}
        </Typography>
        <div className="d-flex gap-2">
          {/* <TextField
            select
            autoFocus
            label="Maintenance Type"
            value={form.maintenance_type}
            onChange={(e) =>
              handleInputChange("maintenance_type", e.target.value)
            }
            placeholder="Select maintenance type"
            fullWidth
          >
            {maintenanceTypeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField> */}

          {/* <TextField
            label="Remarks"
            value={form.remarks}
            onChange={(e) => handleInputChange("remarks", e.target.value)}
            placeholder="Enter remarks..."
            fullWidth
          /> */}

          <Box sx={{ width: "100%" }}>
            <Tabs
              value={form.maintenance_type || false}
              onChange={(e, newValue) =>
                handleInputChange("maintenance_type", newValue)
              }
              variant="fullWidth"
              textColor="primary"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                "& .MuiTab-root": {
                  flex: 1, // equal width
                  textTransform: "none",
                  borderRadius: "9999px", // pill shape for each
                  minHeight: "40px",
                  fontWeight: 500,
                  border: "1px solid #ddd", // ✅ light border for unselected
                  marginRight: "8px", // spacing between pills
                  backgroundColor: "#fafafa", // white by default
                  "&:last-of-type": {
                    marginRight: 0, // no extra margin on last pill
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#1976d2", // ✅ filled when selected
                    color: "#fff",
                    borderColor: "#1976d2",
                  },
                },
              }}
            >
              {maintenanceTypeOptions.map((option) => (
                <Tab
                  key={option.value}
                  value={option.value}
                  label={option.label}
                />
              ))}
            </Tabs>
          </Box>
        </div>

        <div className="mt-3">
          <TextField
            label="Description"
            multiline
            rows={4}
            fullWidth
            value={form.description}
            onChange={(e) => handleInputChange("description", e.target.value)}
            placeholder="Enter description for maintenance..."
            variant="outlined"
            autoFocus
            inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
                backgroundColor: "#fafafa",
              },
            }}
            helperText={`${form.description.length} / ${MAX_DESCRIPTION_LENGTH} characters`}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleMaintenance}
          variant="contained"
          color="error"
          disabled={!form.maintenance_type || !form.description}
        >
          {loading && <Spinner animation="border" size="sm" className="me-2" />}
          Confirm Maintenance
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssetMaintenanceModal;
